import { API_PREFIX } from '../config/appConfig';
import ApiService from './api.service';

const UserService = {

  getUsersByRole: async () => {
    console.log('%c [DEBUG] UserService - getUsersByRole ENTER', 'background: #222; color: #bada55');

    try {
      const response = await fetch(`${API_PREFIX}/users/by-role`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Errore durante il recupero degli utenti per ruolo');
      }

      console.log('%c [DEBUG] UserService - getUsersByRole SUCCESS', 'background: #222; color: #01FF70', {
        response: data
      });

      return data;
    } catch (error) {
      console.error('%c [DEBUG] UserService - getUsersByRole ERROR', 'background: #222; color: #FF4136', {
        error: error.message
      });
      throw error;
    }
  },

  // Metodo per ottenere i dettagli di un utente dato il suo ID
  getUserDetails: async (userId) => {
    console.log('%c [DEBUG] UserService - getUserDetails ENTER', 'background: #222; color: #bada55', {
      userId
    });

    try {
      const response = await fetch(`${API_PREFIX}/users/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Errore durante il recupero dei dettagli dell\'utente');
      }

      console.log('%c [DEBUG] UserService - getUserDetails SUCCESS', 'background: #222; color: #01FF70', {
        response: data
      });

      return data;
    } catch (error) {
      console.error('%c [DEBUG] UserService - getUserDetails ERROR', 'background: #222; color: #FF4136', {
        error: error.message
      });
      throw error;
    }
  },
  // Professionista Creation
  createDoctor: (doctorData) => ApiService.fetch('users/doctors', {
    method: 'POST',
    body: JSON.stringify(doctorData)
  }),
  // Disable / Activa Login
  toggleUserLogin: (userId) => ApiService.fetch(`users/${userId}/toggle-login`, {
    method: 'PUT'
  }),
  // Delete User
  deleteUser: (userId) => ApiService.fetch(`users/${userId}`, {
    method: 'DELETE'
  }),

  getTherapists: async (searchTerm) => {

    const token = localStorage.getItem('auth_token');

    try {
      const response = await fetch(`${API_PREFIX}/therapist/search`, {
        method: 'POST',
        body:
          JSON.stringify({
            email: searchTerm,
          })
        ,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      return data;
    } catch (error) {
      console.log(error)
      throw error;
    }

  },

  getSearchUsers: async (searchTerm) => {

    const token = localStorage.getItem('auth_token');

    try {
      const response = await fetch(`${API_PREFIX}/patient/search`, {
        method: 'POST',
        body:
          JSON.stringify({
            email: searchTerm,
          })
        ,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      return data;
    } catch (error) {
      console.log(error)
      throw error;
    }

  },

  associateTherapistAndUser: async (userId, therapistId) => {

    const token = localStorage.getItem('auth_token');

    try {
      const response = await fetch(`${API_PREFIX}/therapist/add-prof-patient-association`, {
        method: 'POST',
        body:
          JSON.stringify({
            therapist_id: therapistId,
            patient_id: userId
          })
        ,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      return data;
    } catch (error) {
      console.log(error)
      throw error;
    }

  },

  removeTherapistUser: async (userId, therapistId) => {

    const token = localStorage.getItem('auth_token');

    try {
      const response = await fetch(`${API_PREFIX}/therapist/remove-prof-patient-association`, {
        method: 'POST',
        body:
          JSON.stringify({
            therapist_id: therapistId,
            patient_id: userId
          })
        ,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      return data;
    } catch (error) {
      console.log(error)
      throw error;
    }

  },

  getUserTherapist: async (userId) => {

    const token = localStorage.getItem('auth_token');

    try {
      const response = await fetch(`${API_PREFIX}/patient/${userId}/therapists`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      return data;
    } catch (error) {
      console.log(error)
      throw error;
    }
  },

  getTherapistUsers: async (userId) => {

    const token = localStorage.getItem('auth_token');

    try {
      const response = await fetch(`${API_PREFIX}/therapist/${userId}/patients`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      return data;
    } catch (error) {
      console.log(error)
      throw error;
    }
  },
};

export default UserService;
